import { extendTheme } from "@chakra-ui/react";
import { brandConfig } from "./brandConfig";

/**
 * Centralized Chakra UI Theme Configuration
 *
 * This theme file integrates brandConfig fonts and ensures consistent typography
 * across the entire application.
 */

const theme = extendTheme({
  // Color mode configuration
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },

  // Typography configuration from brandConfig
  fonts: {
    heading: brandConfig.fonts.heading,
    body: brandConfig.fonts.body,
  },

  // Global styles
  styles: {
    global: {
      // HTML scroll behavior - disable initially to prevent flash
      html: {
        scrollBehavior: 'auto',
        overflowX: 'hidden',
        overscrollBehaviorY: 'none',
      },
      // Body-level styles
      body: {
        fontFamily: brandConfig.fonts.body,
        overflowX: 'hidden',
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        position: 'relative',
        // Prevent background flash during transitions
        background: '#FFFFFF',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
      },
      // Heading styles
      "h1, h2, h3, h4, h5, h6": {
        fontFamily: brandConfig.fonts.heading,
      },
      // Essential reset
      "*": {
        boxSizing: 'border-box',
      },
      // Link hover transitions - keep minimal
      "a": {
        transition: 'color 0.15s ease-in-out',
        textDecoration: 'none',
      },
      // Button transitions - keep minimal
      "button": {
        transition: 'background-color 0.15s ease-in-out, transform 0.15s ease-in-out',
      },
      // Image loading - optimize for quick rendering
      "img": {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
        // Prevent flash while images load
        opacity: 1,
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
      },
      // Prevent layout shift during loading
      "#root": {
        minHeight: '100vh',
        position: 'relative',
        // Prevent any background flash
        background: '#FFFFFF',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
      },
      // Optimize page containers
      "[data-chakra-container]": {
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
      },
      // Prevent flash on route changes
      ".chakra-portal": {
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
      }
    },
  },

  // Component-specific overrides
  components: {
    Heading: {
      baseStyle: {
        fontFamily: brandConfig.fonts.heading,
      },
    },
    Text: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
    Button: {
      baseStyle: {
        fontFamily: brandConfig.fonts.body,
      },
    },
  },
});

export default theme;
